module.exports = __webpack_public_path__ + "static/media/logo-conceicaolagoacu.885245a4.png";